// Gate event Promotion pages before mounting their data-reading children.
// RoleGuard owns manager/admin identity; canonical purchasedAddOns.social and
// its stored promotion alias own entitlement. Internal admin routes stay separate.
import React from "react";
import { useEventContext } from "../../hooks/use_event_context";
import { hasPurchasedAddOn } from "../../utils/event_addons";
import FullPageSpinner from "../../components/FullPageSpinner";
import AddonRequired from "../../components/AddonRequired";

export default function EventPromotionGuard({ children }) {
  const { eventId, eventslug, eventDoc, eventLoading } = useEventContext({ redirectIfNotFound: false });
  if (eventLoading || !eventId || !eventDoc) return <FullPageSpinner />;
  if (!hasPurchasedAddOn(eventDoc, "social")) return <AddonRequired
    title="Social Promotion Required" eventslug={eventslug}
    description="Enable the Social Promotion Power Up to create event promotions and connect social accounts." />;
  return children;
}
